import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-right-top",
  "use": "icon-si-glyph-arrow-thin-right-top-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-right-top\" id=\"icon-si-glyph-arrow-thin-right-top\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1180</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.908,0.021 L16.925,8.952 C16.925,9.6 16.314,9.981 16.03,9.979 C15.46,9.978 15.082,9.515 15.081,8.945 L15.071,3.388 L2.677,15.588 C2.314,15.949 1.721,15.942 1.349,15.57 C0.977,15.198 0.968,14.604 1.332,14.243 L13.478,1.931 L8.145,1.923 C7.575,1.921 7.083,1.547 7.083,0.979 C7.08,0.409 7.568,0.00300000002 8.14,0.00500000003 L16.908,0.021 L16.908,0.021 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-right-top.svg
// module id = 4cGk
// module chunks = 62